import styled from 'styled-components';
import useTranslation from '../../../../hooks/useTranslation';
import { Tag } from '../../../generic/Core';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

const Card = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0.75rem 1rem;
    border-radius: 0.75rem;
    border: 2px solid
        ${props => (props.$selected ? props.theme.card.active : props.theme.card.unselected)};
    background: ${props => props.theme.card.background};
    box-shadow: ${props =>
        props.$selected ? props.theme.card.boxShadow : 'none'};
    cursor: pointer;
`;

const CardColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

const CardTitle = styled.div`
    font-weight: 600;
    font-size: var(--font-XS);
`;

const CardSub = styled.div`
    font-size: var(--font-XXS);
    color: ${props => props.theme.font.active};
`;

const RightTitle = styled.div`
    font-weight: 600;
    font-size: var(--font-XS);
    text-align: right;
`;

const RightSub = styled.div`
    font-size: var(--font-XXS);
    text-align: right;
`;

const ActionBar = styled.div`
    margin-top: 0.5rem;
    display: flex;
    justify-content: flex-end;
`;

const ActionButton = styled.button`
    border-radius: 999px;
    border: none;
    padding: 0.25rem 0.75rem;
    font-size: var(--font-XS);
    background: ${props => props.theme.btn.primary};
    color: ${props => props.theme.btn.font};
    cursor: pointer;

    &:hover {
        background: ${props => props.theme.btn.active.primary};
    }
`;

const Decorator = styled.span`
    font-size: var(--font-XXS);
    text-align: right;
    //color: ${props => props.theme.font.active};
    font-weight: 400;
`


const CardList = ({
    data,
    activeId,
    layout,
    action,
    onActionClick,
    onItemClick,
    testId
}) => {
    const { t } = useTranslation();

    // Guard against null/undefined data
    const safeData = Array.isArray(data) ? data : [];

    const getValue = (item, configPart) => {
        if (!configPart || !item) return '';
        const value = item[configPart.field];
        const deco = configPart.decorator ? item[configPart.decorator] : undefined;

        if (configPart.style === 'tag') {
            return (
                <Tag $variant="primary"
                    $padding="0.25rem 0.5rem"
                    $fontSize="var(--font-XXS)"
                    $radius="1rem"
                >
                    {value}
                    <Decorator>{deco ? ` ${deco}` : ''}</Decorator>
                </Tag>
            );
        }

        return (
            <>
                {value}
                <Decorator>{deco ? ` ${deco}` : ''}</Decorator>
            </>
        );
    };

    // Guard against missing layout
    if (!layout) {
        console.warn('[CardList] Missing layout configuration');
        return null;
    }

    return (
        <Container>
            {safeData.map((item, index) => {
                const isSelected = item?.id === activeId;

                return (
                    <div key={item.id ?? index} data-testid={`${testId}.${index + 1}`}>
                        <Card
                            $selected={isSelected}
                            onClick={() => onItemClick(item)}
                        >
                            <CardColumn>
                                <CardTitle>
                                    {getValue(item, layout.leftTitle)}
                                </CardTitle>
                                <CardSub>
                                    {getValue(item, layout.leftContent)}
                                </CardSub>
                            </CardColumn>
                            <CardColumn>
                                <RightTitle>
                                    {getValue(item, layout.rightTitle)}
                                </RightTitle>
                                <RightSub>
                                    {getValue(item, layout.rightContent)}
                                </RightSub>
                            </CardColumn>
                        </Card>
                        {isSelected && action && (
                            <ActionBar>
                                <ActionButton
                                    type="button"
                                    data-testid={`${testId}.${index + 1}.action`}
                                    onClick={e => {
                                        e.stopPropagation();
                                        onActionClick();
                                    }}
                                >
                                    {t(action.buttonLabel)}
                                </ActionButton>
                            </ActionBar>
                        )}
                    </div>
                );
            })}
        </Container>
    );
};

export default CardList;